import React from "react";
import { formatCell, toTitleCase } from "./analyticsUtils";

const DataTable = ({
  title,
  subtitle,
  actions,
  rows = [],
  columns = [],
  emptyText = "No rows found.",
}) => {
  const resolvedColumns =
    columns.length > 0
      ? columns
      : rows[0]
      ? Object.keys(rows[0]).map((key) => ({ key, label: toTitleCase(key) }))
      : [];

  return (
    <div className="rounded-3xl border border-slate-200 bg-white p-5 shadow-[0_10px_40px_rgba(15,23,42,0.06)]">
      {(title || actions) && (
        <div className="mb-4 flex flex-wrap items-start justify-between gap-3">
          <div>
            {title && <h4 className="text-lg font-semibold text-slate-900">{title}</h4>}
            {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
          </div>
          {actions}
        </div>
      )}
      <div className="overflow-x-auto">
        <table className="min-w-full border-separate border-spacing-0 text-sm">
          <thead>
            <tr className="border-b bg-gray-50">
              {resolvedColumns.map((column) => (
                <th
                  key={column.key}
                  className="border-b border-slate-200 bg-slate-50/80 px-4 py-3 text-left text-xs font-semibold uppercase tracking-[0.12em] text-slate-500"
                >
                  {column.label || toTitleCase(column.key)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={index} className="transition-colors hover:bg-slate-50/70">
                {resolvedColumns.map((column) => (
                  <td key={column.key} className="border-b border-slate-100 px-4 py-3 align-top text-slate-700">
                    {column.render
                      ? column.render(row[column.key], row)
                      : formatCell(row[column.key])}
                  </td>
                ))}
              </tr>
            ))}
            {rows.length === 0 && (
              <tr>
                <td
                  className="p-4 text-center text-muted italic"
                  colSpan={Math.max(1, resolvedColumns.length)}
                >
                  {emptyText}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DataTable;

